import { useHierarchyArea } from '@plarium/hierarchy-react';
import React from 'react';

import { Grid, Typography, CircularProgress } from '@gogame/components';
import { withFormFieldGroupFormField } from '@gogame/form';

import { loadConversionInfoSchema } from 'scenes/Integrations/sources/conversions/conversions';

import { PROVIDER_TYPE } from '../constants';
import FieldSetBySchema from './FieldSetBySchema';

const ConversionInfo = withFormFieldGroupFormField()(({ name }) => {
  const { data, loading, error } = useHierarchyArea({
    name: name,
    source: loadConversionInfoSchema,
    depends: [PROVIDER_TYPE],
  });

  return (
    <React.Fragment>
      {data ? <FieldSetBySchema name={name} {...data} /> : null}
      {error ? (
        <Grid item xs={12}>
          <Typography color={'error'}>{error}</Typography>
        </Grid>
      ) : null}
      {loading ? (
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      ) : null}
    </React.Fragment>
  );
});

export default ConversionInfo;
